// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".base-textarea{display:block}.base-textarea__field{display:block;width:100%;margin-top:12px;resize:vertical;outline:none}.base-textarea__error{display:block;margin-top:4px;padding-left:12px;font-size:12px;line-height:16px;color:var(--1mqhmob);text-align:left}", ""]);
// Exports
module.exports = exports;
